module.exports = __webpack_public_path__ + "../resources/img/pv_cal_img1.68164e3b.png";